import { z } from 'zod'

export const sweepAccountsProductSchema = z.object({
  indexName: z.string(),
  interestRateIndex: z.number(),
  name: z.string(),
  type: z.string().optional()
})

export type SweepAccountsProduct = z.infer<typeof sweepAccountsProductSchema>

export const sweepAccountsProfitsTotalSchema = z.object({
  product: sweepAccountsProductSchema.nullable(),
  returnAmount: z.number()
})

export type SweepAccountsProfitsTotal = z.infer<typeof sweepAccountsProfitsTotalSchema>
